import {
  signUp as signUpApi,
  confirmSignUp,
  signIn as signInApi,
  forgotPassword as fgPasswordApi,
  resetPassword as resetPasswordApi,
  setUserToken,
} from '../_shared/services/authentication.service';
import {
  getUser,
  updateUser as updateUserApi,
} from '../_shared/services/manage-users.service';
import { ACTIONS } from '../actions/reducers';
import { get } from 'lodash';

export const signUp = (username, password, company, opts = {}) => async (
  dispatch,
  getState
) => {
  const resp = await signUpApi(username, password, company, opts);

  dispatch({
    type: ACTIONS.SET_CURRENT_USER,
    payload: { email: username, company, password },
  });

  return resp ? true : false;
};

export const logout = () => {
  localStorage.clear();
  window.location.href = '/login';
};

export const signIn = (username, password, mfaToken) => async (
  dispatch,
  getState,
) => {
  try {
    const resp = await signInApi(username, password, mfaToken);

    dispatch({
      type: ACTIONS.SET_CURRENT_USER,
      payload: {
        email: resp.email,
        password: undefined,
      },
    });

    if (resp) {
      await dispatch(getUserData());
      const user = getState().user;
      await dispatch(updateUser({ ...user, isActive: 1 }));
    }

    return resp ? { success: true } : { success: false };
  } catch (err) {
    // Surface MFA challenges to the login UI instead of treating them as a
    // generic failure (the superadmin needs to be prompted for a 6-digit code).
    const data = (err && err.response && err.response.data) || {};
    if (data.mfaRequired) return { mfaRequired: true, error: data.error };
    if (data.mfaEnrollRequired) return { mfaEnrollRequired: true, error: data.error };
    return { success: false, error: data.error };
  }
};

export const setCurrentUser = (user) => async (
  dispatch,
  getState,
) => {
  dispatch({ type: ACTIONS.SET_CURRENT_USER, payload: user });
}

export const getUserData = () => async (
  dispatch,
  getState,
) => {
  const sState = getState();

  if (sState.user) {
    try {
      const user = await getUser(sState.user.email);
      if (!user.id) {
        return dispatch(logout());
      } else {
        await setUserToken({ dispatch, getState }, user);
        const token = get(getState(), 'user.token', '');
        return dispatch({ type: ACTIONS.SET_CURRENT_USER, payload: { ...user, token } });
      }
    } catch (err) {
      console.warn(err);
      throw new Error(err);
    }
  }
};

export const updateUser = (user) => async (
  dispatch,
  getState,
) => {
  try {
    const u = await updateUserApi({
      ...user,
      userId: user.email,
    });
    dispatch({ type: ACTIONS.SET_CURRENT_USER, payload: u });
    return getState().user;
  } catch (err) {
    console.warn(err);
    throw new Error(err);
  }
};

export const verify = (email, code) => async (
  dispatch,
  getState,
) => {
  let resp = { attributes: {}, error: undefined };
  try {
    resp = await confirmSignUp(email, code);
  } catch (err) {
    resp.error = err;
  }
  return resp;
};

export const forgotPassword = (email) => async (
  dispatch,
  getState,
) => {
  return await fgPasswordApi(email);
};

// Consumes a reset token (from the emailed link) and sets the new password.
// Surfaces the server's error message so the reset screen can display it.
export const resetPassword = (token, newPassword) => async (
  dispatch,
  getState,
) => {
  try {
    return await resetPasswordApi(token, newPassword);
  } catch (err) {
    const e = get(err, 'response.data.error', err.message);
    throw new Error(e);
  }
};
